module.exports = __webpack_public_path__ + "img/jarvis-logo@3x.13dd1430.png";